import { Component, OnInit } from '@angular/core';
import {Language} from '../../../shared/config/language';
import siteSettings from '../../../shared/config/site-settings';

@Component({
  selector: 'app-contact-dialog',
  templateUrl: './contact-dialog.component.html',
  styleUrls: ['./contact-dialog.component.scss']
})
export class ContactDialogComponent implements OnInit {

  siteSettings = siteSettings;
  language = Language;

  constructor() { }

  ngOnInit(): void {
  }

}
